import api from "../../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../../rootReducer";

const findPaymentNotices = createAsyncThunk(
  "paymentNoticesList/find",
  async (params, { getState, rejectWithValue }) => {
    try {
      const state = getState() as RootState;
      const url = new URL(`${api.baseURL}paymentNotice`);
      const { accountSelected } = state.paymentNoticesList;
      url.searchParams.append("sort", "payedAt DESC");
      url.searchParams.append("limit", "100");

      url.searchParams.append(
        "where",
        JSON.stringify({
          company: accountSelected?.company?.id,
          payedAt: {
            "<": new Date(),
          },
        }),
      );
      const token = localStorage.getItem("token");
      const headers = new Headers();
      headers.append("Authorization", `Bearer ${token}`);
      headers.append("Content-Type", "application/json");

      let response = await fetch(url.toJSON(), {
        method: "GET",
        headers: headers,
      });
      if (!response.ok) {
        throw response.statusText;
      }
      let data = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export default findPaymentNotices;
